'use client';

import RichText from 'molecules/RichText';
import HeadingCard from 'molecules/TextCard/headingtextcard';
import TextCard from 'molecules/TextCard/textcard';
import ThreeColumnGrid from 'molecules/ThreeColumnGrid';

import styles from 'components/TextCards/textcards.module.scss';

import type { TextCardsProps } from 'components/TextCards/config';
import type { FC } from 'react';

const TextCards: FC<TextCardsProps> = ({ type, heading, headingCards, textCards }) => (
  <div className={`${styles[type]} ${styles.wrapper}`}>
    <div className={styles.cardListThreeUp}>
      {heading && (
        <div className={styles.content}>
          <RichText content={heading} />
        </div>
      )}
      {type === 'headlineOnly' && (
        <ThreeColumnGrid classes={{ grid: styles.customGrid, gridItem: styles.gridItem }}>
          {headingCards?.map((headingCard, index) => (
            <div key={index} className={styles.headlineCard}>
              <HeadingCard {...headingCard} />
            </div>
          ))}
        </ThreeColumnGrid>
      )}

      {(type === 'capps' || type === 'cappsContained') && (
        <ThreeColumnGrid classes={{ grid: styles.customGrid, gridItem: styles.gridItem }}>
          {textCards?.map((textCard, index) => (
            <div key={index} className={`${styles.cappsCard} ${styles[type]}`}>
              <TextCard {...textCard} type={type} />
            </div>
          ))}
        </ThreeColumnGrid>
      )}
    </div>
  </div>
);

export default TextCards;
